import React from 'react';

/** Label boven, veld full-width binnen mpp-card. */
export default function MppField({ label, hint, children, className = '' }) {
  return (
    <div className={`mpp-field ${className}`.trim()}>
      {label ? <span className="mpp-field-label">{label}</span> : null}
      {hint ? <span className="mpp-field-hint muted">{hint}</span> : null}
      <div className="mpp-field-control">{children}</div>
    </div>
  );
}
